import { NgClass } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, computed, HostBinding, Input, input, output } from '@angular/core';

import { ButtonModule, copyToClipboard, IconModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { SafeHtmlPipe } from '@pp/core/pipes';

import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'pp-details-value',
  imports: [IconModule, ButtonModule, TooltipComponent, TranslateModule, NgClass, SafeHtmlPipe],
  templateUrl: './details-value.component.html',
  styleUrl: './details-value.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsValueComponent {
  @HostBinding('class.in-row') @Input({ transform: booleanAttribute }) inRow: boolean;
  readonly label = input<string>();
  readonly labelClass = input<string | string[]>('');
  readonly labelTooltip = input<string | string[]>('');
  @Input() value: string | number | boolean;
  readonly valueClass = input<string | string[]>('');
  readonly valueToCopy = input<string | number | boolean>();
  readonly isCopyBtn = input<boolean, unknown>(undefined, { transform: booleanAttribute });
  readonly stopPropagation = input<boolean, unknown>(undefined, { transform: booleanAttribute });
  readonly ellipsis = input<boolean, unknown>(undefined, { transform: booleanAttribute });
  readonly contentWidth = input<boolean, unknown>(undefined, { transform: booleanAttribute });
  readonly maxWidth = input<number | string>();
  readonly copied = output<string>();

  maxWidthStyle = computed(() => (this.maxWidth() ? `${this.maxWidth()}px` : 'unset'));

  copyToClipboard(event: MouseEvent): void {
    if (this.stopPropagation()) {
      event.stopPropagation();
    }

    const textToCopy = this.valueToCopy() || this.value;
    copyToClipboard(textToCopy.toString());
    this.copied.emit(textToCopy.toString());
  }
}
